function toReportNumber(value: string | number): number {
    if (typeof value === 'number') {
        return value;
    }

    const parsed = Number.parseFloat(value);
    return Number.isNaN(parsed) ? 0 : parsed;
}

export function formatReportCurrency(value: string | number): string {
    const num = toReportNumber(value);
    const isZero = num === 0;

    return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: isZero ? 0 : 2,
        maximumFractionDigits: isZero ? 0 : 2,
    }).format(num);
}

export function formatReportAxisCurrency(value: string | number): string {
    const num = toReportNumber(value);

    if (num === 0) {
        return '0';
    }

    return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(Math.round(num));
}

export function formatReportPercent(value: string | number): string {
    const num = toReportNumber(value);
    const oneDecimal = num.toFixed(1);

    if (oneDecimal.endsWith('.0')) {
        return `${Number.parseFloat(oneDecimal).toFixed(0)}%`;
    }

    return `${oneDecimal}%`;
}
